import React, { useState, useEffect } from 'react';
import { FaBuilding, FaUser, FaEdit, FaFile, FaExternalLinkAlt, FaTrash, FaCopy } from 'react-icons/fa';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { Typography, Button } from '@mui/material';
import Paper from '@mui/material/Paper';
import { Link, useHistory } from 'react-router-dom';

import { supabase } from "../../../supabaseClient";

import { generateHash } from '../../../utils'

export default function Companies() {
  const [companies, setCompanies] = useState([]);
  const history = useHistory();

  // get companies using supabase
  const getData = async () => {
    const { data, error } = await supabase
      .from('companies')
      .select('*');

    if (error) {
      console.log(error);
    } else {
      setCompanies(data);
    }
  };


  useEffect(() => {
    getData();
  }, []);

  const handleCompanyClick = (companyId) => {
    console.log(`Clicked on company with id ${companyId}`);
    //history.push(`/admin/companies/${companyId}`);
  };

  const handleEditCompany = (companyId) => {
    console.log(`Clicked on edit button for company with id ${companyId}`);
    history.push(`/admin/companies/${companyId}/edit`);
  };

  const handleDeleteCompany = async (companyId) => {
    const companyName = prompt('Por favor, ingresa el nombre de la empresa para confirmar la eliminación:');
    
    // Verifica si el nombre ingresado coincide con el nombre de la empresa
    if (companyName === companies.find(company => company.id === companyId)?.name) {
      try {
        // Elimina la empresa de la base de datos
        await supabase.from('companies').delete().eq('id', companyId);
  
        // Actualiza la lista de empresas después de borrar
        getData();
      } catch (error) {
        console.log(error);
      }
    } else {
      alert('El nombre de la empresa no coincide. La eliminación no se ha confirmado.');
    }
  };

  const handleDuplicateCompany = async (companyId) => {
    const company = companies.find((company) => company.id === companyId);
  
    if (company) {
      const confirmMessage = `¿Estás seguro de duplicar la empresa "${company.name}"?`;
      const confirmed = window.confirm(confirmMessage);
  
      if (confirmed) {
        try {
          // Clona todos los campos de la empresa
          const clonedData = { ...company };

          // Elimina el ID y cualquier otro campo que no desees duplicar
          delete clonedData.id;

          // Inserta la empresa clonada en la base de datos utilizando Supabase
          const { data, error } = await supabase
            .from('companies')
            .insert(clonedData);

          if (error) {
            throw new Error(error.message);
          }

          // Actualiza la lista de empresas después de duplicar
          getData();
        } catch (error) {
          console.log(error);
        }
      }
    }
  };

  const handleGetLink = (companyId) => {
    window.open(`${window.location.origin}?company=${companyId}`, '_blank');
  };

  return (
    <>
      <Paper
        sx={{
          p: 2,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Typography>Empresas</Typography>
        <Table size="small">
        <TableHead>
            <TableRow>
              <TableCell>Nombre</TableCell>
              <TableCell>Codigo de registro</TableCell>
              <TableCell align="right">Editar</TableCell>
              <TableCell align="right">Borrar</TableCell>
              <TableCell align="right">Duplicar</TableCell>
              <TableCell align="right">Enlace</TableCell>
              <TableCell align="right">Estado</TableCell>
              <TableCell align="right">Modo</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {companies.map((company) => (
              <TableRow
                key={company.id}
                onClick={() => handleCompanyClick(company.id)}
                style={{ cursor: 'pointer' }}
              >
                <TableCell
                  style={{ backgroundColor: company.color }}
                >
                  <FaBuilding style={{ marginRight: '0.5rem' }} />
                  {company.name}
                </TableCell>
                <TableCell>
                  <FaFile style={{ marginRight: '0.5rem' }} />
                  {generateHash(company.name)}
                </TableCell>
                <TableCell align="right">
                  <Button onClick={() => handleEditCompany(company.id)}>
                    <FaEdit />
                  </Button>
                </TableCell>
                <TableCell align="right">
                  <Button onClick={() => handleDeleteCompany(company.id)}>
                    <FaTrash />
                  </Button>
                </TableCell>
                <TableCell align="right">
                  <Button onClick={() => handleDuplicateCompany(company.id)}>
                    <FaCopy />
                  </Button>
                </TableCell>
                <TableCell align="right">
                    {`${window.location.origin}?company=${company.id}`}
                </TableCell>
                <TableCell align="right" style={{ backgroundColor: company.demo ? 'red' : 'green' }}>
                  {company.demo ? 'DEMO' : 'ACTIVO'}
                </TableCell>
                <TableCell align="right" style={{ backgroundColor: company.simple_mode ? 'red' : 'green' }}>
                  {company.simple_mode ? 'SIMPLE' : 'COMPLETO'}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>

        </Table>
      </Paper>
    </>
  );
}
